export default {
  common: {
    filters: {
      startingDate: {
        label: 'Starting date',
        placeholder: 'YYYY-MM-DD hh:mm:ss'
      },
      endDate: {
        label: 'End date',
        placeholder: 'YYYY-MM-DD hh:mm:ss'
      },
      operationIds: {
        label: 'Operation Id(s)',
        placeholder: 'Select operation id(s)'
      },
      statuses: {
        label: 'Status(es)',
        placeholder: 'Select status(es)'
      },
      senderPhoneNumber: {
        label: 'Sender(s) phone number(s)',
        placeholder: 'Select sender(s) phone number(s)'
      },
      resultsNumber: {
        label: 'Number of results to display at page'
      }
    }
  }
};
